import styled, { css } from 'styled-components';

import type { PriceSize } from '../Price';
import { Typography } from '../Typography';

import { getFontSize } from '../Price/Price.styles';

export const ComplimentaryText = styled(Typography)<{ $size: PriceSize }>`
  font-size: ${({ $size }) => getFontSize($size, true)};
  text-align: right;
  ${({ $size, theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${$size === 'inherited' ? 'inherit' : theme.colors.primaryBlue};
  `}

  span {
    font-size: ${({ $size }) => getFontSize($size, false)};
  }
`;
